import moment from 'moment';
import { Timestamp } from 'api/models';
import { getCurrentTimeStampForTimezone } from 'utils/timezone';
import { orderedDays } from './ordered-days';

const dayValMap = orderedDays.reduce((acc, day, index) => {
  return {
    ...acc,
    [day.toUpperCase()]: index,
  };
}, {});

export const getNextSendTime = (
  frequencyTime: string | number,
  frequencyDay: string,
  timezone?: string,
): string => {
  const currentWeekday = moment(
    getCurrentTimeStampForTimezone(timezone),
  ).weekday();
  const weekDay = dayValMap[frequencyDay];

  let isNextEventinSameWeek = false;
  let nextWeekEvent = moment(getCurrentTimeStampForTimezone(timezone)).day(
    weekDay,
  );

  if (currentWeekday < weekDay) {
    isNextEventinSameWeek = true;
  } else if (currentWeekday === weekDay) {
    const timeIsOver = moment(getCurrentTimeStampForTimezone(timezone)).isAfter(
      moment(frequencyTime, 'h:mm'),
    );

    // check if time is already over
    isNextEventinSameWeek = !timeIsOver;
  }

  if (!isNextEventinSameWeek) {
    nextWeekEvent = nextWeekEvent.add(1, 'week');
  }

  return nextWeekEvent
    ? `${nextWeekEvent.format('ddd, DD MMM')}, ${moment(
        frequencyTime,
        'hh:mm',
      ).format('h:mm A')}`
    : '';
};

export const findNextupdate = (
  ts: Timestamp,
  timezone?: string,
): string | null => {
  const _ts = new Date(ts).toLocaleString('en-US', { timeZone: timezone });
  const time = moment(_ts);

  return time.isValid() ? time.format('ddd, DD MMM, h:mm A') : null;
};
